import * as React from 'react';
import { useEffect, useState } from "react";
import { Box, Grid } from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { connect } from "react-redux";
import { ApplicationState } from "../../redux/reducers";
import { ICategoriaServicio } from "../../redux/types/servicioAdicionalType";
import { ServicioAdicional as ServicioGuia } from "../../entities/catalogos/ServicioAdicional";
import { IDocumento } from "../../interfaces/IDocumento";
import ServicioAdicionalItemGuia from "./ServicioAdicionalItemGuia";
import Help from '../help/Help';
import { traducirMessage } from '../../blocks/traductor';

interface OwnProps {
    servicios: ServicioGuia[];
    onSelect: (servicio: ServicioGuia) => void;
    agruparPorCategoria?: boolean;
    documentosCliente?: IDocumento[];
}

interface StateProps {
    categorias: ICategoriaServicio[];
}

type Props = OwnProps & StateProps;

const categoriaComentario = new Map<string, string>([
    ["Maniobra", traducirMessage(168)],
    ["Puertos", traducirMessage(170)],
    ["Post Servicio", traducirMessage(172)],
    ["Punto con Cliente", traducirMessage(171)]
]);

const esCategoriaIdValida = (id: number | undefined | null): id is number =>
    typeof id === "number" && id > 0;

const ServicioAdicionalListaGuia = ({
    servicios,
    onSelect,
    agruparPorCategoria = false,
    categorias,
    documentosCliente = []
}: Props) => {
    const [categoriasSeccion, setCategoriasSeccion] = useState<ICategoriaServicio[]>([]);

    useEffect(() => {
        if (!agruparPorCategoria || !servicios?.length || !categorias?.length) {
            setCategoriasSeccion([]);
            return;
        }
        const categoriasId = [
            ...new Set(
                servicios
                    .map(sa => sa.categoriaId)
                    .filter(esCategoriaIdValida)
            )
        ];
        if (categoriasId.length) {
            setCategoriasSeccion(categorias.filter(c => categoriasId.includes(c.id)));
        } else {
            setCategoriasSeccion([]);
        }
    }, [servicios, categorias, agruparPorCategoria]);

    const handleAccordion = (id: number) => (_event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setCategoriasSeccion(prev =>
            prev.map(c => (c.id !== id ? c : { ...c, expanded: isExpanded }))
        );
    };

    if (!agruparPorCategoria) {
        return (
            <Grid container spacing={1}>
                {servicios.map(sa => (
                    <ServicioAdicionalItemGuia
                        key={sa.id}
                        value={sa}
                        onSelect={onSelect}
                        documentosCliente={documentosCliente}
                    />
                ))}
            </Grid>
        );
    }

    if (!categoriasSeccion.length) {
        return null;
    }

    return (
        <>
            {categoriasSeccion.map((c, index) => {
                const serviciosCategoria = servicios.filter(
                    sa => esCategoriaIdValida(sa.categoriaId) && sa.categoriaId === c.id
                );
                if (!serviciosCategoria.length) {
                    return null;
                }
                return (
                    <Accordion
                        key={c.id ?? index}
                        expanded={c.expanded}
                        onChange={handleAccordion(c.id)}
                        style={{ marginBottom: "1.5rem", width: "100%" }}
                    >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Box display="flex">
                                {localStorage.getItem("idioma") === 'en-US' &&
                                    <Box flexGrow={1}>
                                        <b style={{ paddingLeft: c.nombre === "Mercancia" ? "0px" : "30px" }}>
                                            {c.etiquetaCategoriaServicioAdicional?.nombre ?? c.nombre}
                                        </b>
                                    </Box>
                                }
                                {localStorage.getItem("idioma") !== 'en-US' &&
                                    <Box flexGrow={1}>
                                        <b style={{ paddingLeft: c.nombre === "Mercancia" ? "0px" : "30px" }}>
                                            {c.nombre}
                                        </b>
                                    </Box>
                                }
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Box display="flex">
                                <Box>
                                    {categoriaComentario.has(c.nombre) &&
                                        <Help
                                            comments={categoriaComentario.get(c.nombre) ?? ""}
                                            size="small"
                                            customStyle={{ bottom: "10px", left: "-15px" }}
                                        />
                                    }
                                </Box>
                            </Box>
                            <Grid container spacing={1}>
                                {serviciosCategoria.map(sa => (
                                    <ServicioAdicionalItemGuia
                                        key={sa.id}
                                        value={sa}
                                        onSelect={onSelect}
                                        documentosCliente={documentosCliente}
                                    />
                                ))}
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                );
            })}
        </>
    );
};

const mapStateToProps = (state: ApplicationState) => ({
    categorias: state.categoriasServicios ?? []
});

export default connect(mapStateToProps)(ServicioAdicionalListaGuia);
